export const LoadingPage = () => (
    <div
        className="absolute left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-neutral-100"
        role="status"
        aria-label="Loading"
    >
        <div className="text-gray-600">
            <div className="loader" />
        </div>
        <style>{`
                .loader {
                    width: 50px;
                    aspect-ratio: 1;
                    border-radius: 50%;
                    border: 8px solid rgb(var(--primary-400));
                    border-right-color: rgb(var(--primary-700));
                    animation: l2 1s infinite linear;
                }
                @keyframes l2 {
                    to {
                        transform: rotate(1turn);
                    }
                }
            `}</style>
    </div>
);
